import { create } from 'zustand';

export interface DialogConfig {
	title: string;
	description: string;
	variant: 'warning' | 'error' | 'info';
	primaryAction: {
		label: string;
		handler: () => void | Promise<void>;
	};
	secondaryAction?: {
		label: string;
		handler: () => void;
	};
}

interface GlobalDialogState {
	isOpen: boolean;
	config: DialogConfig | null;
	openDialog: (config: DialogConfig) => void;
	closeDialog: () => void;
}

export const useGlobalDialogStore = create<GlobalDialogState>((set) => ({
	isOpen: false,
	config: null,
	openDialog: (config) => set({ isOpen: true, config }),
	closeDialog: () => set({ isOpen: false, config: null }),
}));
